export function extractApiErrorMessage(err: unknown): string {
    if (err && typeof err === 'object') {
        const data = (err as Record<string, unknown>).data;
        if (data && typeof data === 'object') {
            const d = data as Record<string, unknown>;
            if (typeof d.message === 'string') return d.message;
            if (typeof d.error === 'string') return d.error;
        }
    }
    return 'An unexpected error occurred. Please try again.';
}
